import script from "./PermissionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionsPage.vue?vue&type=script&setup=true&lang=js"

import "./PermissionsPage.vue?vue&type=style&index=0&id=4a5fb8c4&lang=scss"

const __exports__ = script;

export default __exports__